export const version = {
  timeStamp: '2026-09-02 09:47:38 AM -03',
  version: '0.0.13-20260902094738',
}
